var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 50.5a1.5 1.5 0 0 0-1.5-1.5H52V28.5a1.5 1.5 0 0 0-3 0v22a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5Z",
    fill: "#021cf5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.27 44.31a1.51 1.51 0 0 0 .65-.15L28.54 38a1.5 1.5 0 0 0-1.31-2.69L17.64 40a34.51 34.51 0 0 1 65.81.26 33.88 33.88 0 0 1 .93 3.74 1.51 1.51 0 0 0 1.47 1.21h.29a1.52 1.52 0 0 0 1.19-1.76 35.81 35.81 0 0 0-1-4A37.32 37.32 0 0 0 50.5 13a37.7 37.7 0 0 0-35.59 25.66l-4.45-9.12a1.5 1.5 0 1 0-2.69 1.31l6.15 12.62a1.5 1.5 0 0 0 1.35.84ZM93.39 71l-6.16-12.66a1.5 1.5 0 0 0-2-.69L72.61 63.8a1.5 1.5 0 0 0 1.32 2.7L83 62.07A34.5 34.5 0 0 1 16.6 57a1.5 1.5 0 1 0-3 .56A37.51 37.51 0 0 0 86 62.64l4.7 9.63a1.49 1.49 0 0 0 1.35.85 1.39 1.39 0 0 0 .65-.16 1.5 1.5 0 0 0 .69-1.96Z",
    fill: "#021cf5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72.5v7a1.5 1.5 0 0 0 3 0v-7a1.5 1.5 0 0 0-3 0Zm-15.09-8.04-4.95 5a1.51 1.51 0 0 0 2.13 2.13l4.95-5a1.51 1.51 0 0 0-2.13-2.13Z",
    fill: "#021cf5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2162fd17dfd3d7a5590211ba14f02aee.svg";
export { ForwardRef as ReactComponent };